<div class="d-flex row-cols-12">
    <div class="col-12">
    <h3 class="title float-start" translate>Settings.Documents</h3>
    </div>
</div>

<div class="p-4 pt-0">
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <ul class="mt-2 w-100 list-group sourceheader rounded-0">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-12"><span translate="Settings.IntegrationsImportExportSection.Source"></span></div>
                </div>
            </li>
        </ul>
        <app-other [Plugins]="filterPlugins(other)" (UpdateOrganisationPlugins)="updatePlugins($event)"></app-other>
    </div>
</div>
